{
  "SLA": {
    "HEADER": "Соглашения об уровне обслуживания",
    "ADD_ACTION": "Добавить SLA",
    "ADD_ACTION_LONG": "Создать новую политику SLA",
    "DESCRIPTION": "Соглашения об уровне обслуживания (SLA) — это контракты, которые определяют четкие ожидания между вашей командой и клиентами. Они устанавливают стандарты времени ответа и разрешения проблем, создавая основу для подотчетности и обеспечивая последовательный, высококачественный опыт.",
    "LEARN_MORE": "Узнать больше о SLA",
    "LOADING": "Загрузка SLA",
    "PAYWALL": {
      "TITLE": "Обновите тарифный план для создания SLA",
      "AVAILABLE_ON": "Функция SLA доступна только в тарифных планах Business и Enterprise.",
      "UPGRADE_PROMPT": "Обновите ваш тарифный план, чтобы получить доступ к расширенным функциям, таким как управление командой, автоматизация, пользовательские атрибуты и другие.",
      "UPGRADE_NOW": "Обновить сейчас",
      "CANCEL_ANYTIME": "Вы можете изменить или отменить ваш тарифный план в любое время"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Функция SLA доступна только в платных тарифных планах.",
      "UPGRADE_PROMPT": "Перейдите на платный тарифный план, чтобы получить доступ к расширенным функциям, таким как аудит журналов, пропускная способность агентов и другие.",
      "ASK_ADMIN": "Пожалуйста, обратитесь к вашему администратору для обновления."
    },
    "LIST": {
      "404": "В этой учетной записи нет доступных SLA.",
      "EMPTY": {
        "TITLE_1": "Enterprise P0",
        "DESC_1": "Проблемы, поднятые корпоративными клиентами, требующие немедленного внимания.",
        "TITLE_2": "Enterprise P1",
        "DESC_2": "Проблемы, поднятые корпоративными клиентами, требующие быстрого подтверждения."
      },
      "BUSINESS_HOURS_ON": "Рабочие часы включены",
      "BUSINESS_HOURS_OFF": "Рабочие часы отключены",
      "RESPONSE_TYPES": {
        "FRT": "Порог времени первого ответа",
        "NRT": "Порог времени следующего ответа",
        "RT": "Порог времени разрешения",
        "SHORT_HAND": {
          "FRT": "FRT",
          "NRT": "NRT",
          "RT": "RT"
        }
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Название SLA",
        "PLACEHOLDER": "Название SLA",
        "REQUIRED_ERROR": "Название SLA обязательно",
        "MINIMUM_LENGTH_ERROR": "Минимальная длина — 2 символа",
        "VALID_ERROR": "Допускаются только буквы, цифры, дефис и нижнее подчеркивание"
      },
      "DESCRIPTION": {
        "LABEL": "Описание",
        "PLACEHOLDER": "SLA для премиум клиентов"
      },
      "FIRST_RESPONSE_TIME": {
        "LABEL": "Время первого ответа",
        "PLACEHOLDER": "5"
      },
      "NEXT_RESPONSE_TIME": {
        "LABEL": "Время первого ответа",
        "PLACEHOLDER": "5"
      },
      "RESOLUTION_TIME": {
        "LABEL": "Время Завершения",
        "PLACEHOLDER": "60"
      },
      "BUSINESS_HOURS": {
        "LABEL": "Рабочие часы",
        "PLACEHOLDER": "Только в рабочие часы"
      },
      "THRESHOLD_TIME": {
        "INVALID_FORMAT_ERROR": "Пороговое значение должно быть числом и больше нуля"
      },
      "EDIT": "Редактировать",
      "CREATE": "Создать",
      "DELETE": "Удалить",
      "CANCEL": "Отменить"
    },
    "ADD": {
      "TITLE": "Добавить SLA",
      "DESC": "Дружелюбные обещания отличного обслуживания!",
      "API": {
        "SUCCESS_MESSAGE": "SLA успешно добавлен",
        "ERROR_MESSAGE": "Произошла ошибка, пожалуйста, попробуйте снова"
      }
    },
    "DELETE": {
      "TITLE": "Удалить SLA",
      "API": {
        "SUCCESS_MESSAGE": "SLA успешно удален",
        "ERROR_MESSAGE": "Произошла ошибка, пожалуйста, попробуйте снова"
      },
      "CONFIRM": {
        "TITLE": "Подтвердить удаление",
        "MESSAGE": "Вы уверены, что хотите удалить ",
        "YES": "Да, удалить ",
        "NO": "Нет, оставить "
      }
    },
    "EVENTS": {
      "TITLE": "Пропуски SLA",
      "FRT": "Время первого ответа",
      "NRT": "Время первого ответа",
      "RT": "Время разрешения",
      "SHOW_MORE": "еще {count}",
      "HIDE": "Скрыть {count} строк"
    }
  }
}
